import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryTimeInterval } from 'src/app/layout/common/components/order-form/step-time/step-time.service';
import { getNowByTZ } from 'src/app/shared/utils/convert-timezone';

@Pipe({
  name: 'filterIntervals',
})
export class FilterIntervalsPipe implements PipeTransform {
  transform(
    value: DeliveryTimeInterval[],
    currentDate: Date | null,
    deliveryDuration: number | null | undefined,
    timeZone: string | undefined,
  ): DeliveryTimeInterval[] {

    if(!currentDate) {
      return [];
    }
    const now = getNowByTZ(timeZone);

    const deliveryTime = new Date(now.getTime() + (deliveryDuration ?? 0) * 60000);
    const isMidnightTransition = deliveryTime.getDate() - now.getDate() > 0;

    if(value) {
      let intervals = value.filter(item => this.comparedDate(item.date, currentDate, deliveryDuration));

      if(isMidnightTransition && currentDate.getDate() === now.getDate()) {
        intervals = [
          value
            .filter(interval => this.comparedDateForMidnightTransition(interval.date, now, deliveryDuration))
            .reduce((a, b) => a.date > b.date ? a : b) // берем наибольший
        ];
      }

      const mapFromIntervals = new Map(
        intervals.map(interval => [interval.date.getTime(), interval])
      );

      const uniqueIntervals: DeliveryTimeInterval[] = [...mapFromIntervals.values()];
      uniqueIntervals.sort((a: DeliveryTimeInterval, b: DeliveryTimeInterval) => a.date.valueOf() - b.date.valueOf());

      return uniqueIntervals;
    }
    else {
      return [];
    }
  }

  comparedDate(intervalDate: Date, currentDate: Date, deliveryDuration: number | null | undefined): boolean {
    const currentDateWithDelivery =
      deliveryDuration ? new Date(currentDate.getTime() + deliveryDuration * 60000) : currentDate;
    return intervalDate.getDate() === currentDate.getDate() && intervalDate >= currentDateWithDelivery;
  }

  comparedDateForMidnightTransition(intervalDate: Date, now: Date, deliveryDuration: number | null | undefined): boolean {
    const deliveryDateTime =
      deliveryDuration ? new Date(now.getTime() + deliveryDuration * 60000) : now;
    return intervalDate.getDate() === now.getDate() + 1 && intervalDate <= deliveryDateTime;
  }
}
